export default "__VITE_ASSET__CvGau$sz__"